import * as api from '../../../clients/kommunikation';

import {Action} from '@ngrx/store';

export const GET_MITTEILUNGEN_GESENDET_GRUPPIERT = '[KommunikationModul] GetMitteilungenGesendetGruppiert laden';
export const GET_MITTEILUNGEN_GESENDET_GRUPPIERT_AUSFUEHREN = '[KommunikationModul] GetMitteilungenGesendetGruppiert ausführen';
export const GET_MITTEILUNGEN_GESENDET_GRUPPIERT_ERFOLGREICH = '[KommunikationModul] GetMitteilungenGesendetGruppiert laden erfolgreich';
export const GET_MITTEILUNGEN_GESENDET_GRUPPIERT_FEHLER = '[KommunikationModul] GetMitteilungenGesendetGruppiert Ladefehler';
export const GET_MITTEILUNGEN_GESENDET_GRUPPIERT_NICHT_AUSGEFUEHRT = '[KommunikationModul] GetMitteilungenGesendetGruppiert nicht ausgeführt (evtl. Offline)';


export class GetMitteilungenGesendetGruppiertAction implements Action {
    readonly type = GET_MITTEILUNGEN_GESENDET_GRUPPIERT;
        constructor( public korrelation_id:string , public optPayload: any = null) {}
    }
export class GetMitteilungenGesendetGruppiertAusfuehrenAction implements Action {
    readonly type = GET_MITTEILUNGEN_GESENDET_GRUPPIERT_AUSFUEHREN;
        constructor( public korrelation_id:string , public optPayload: any = null) {}
    }
export class GetMitteilungenGesendetGruppiertErfolgreichAction implements Action {
    readonly type = GET_MITTEILUNGEN_GESENDET_GRUPPIERT_ERFOLGREICH;
        constructor(public payload: Array<api.DatumGruppeMitteilungen>,  public korrelation_id:string , public optPayload: any = null) {}
    }
export class GetMitteilungenGesendetGruppiertFehlerAction implements Action {
    readonly type = GET_MITTEILUNGEN_GESENDET_GRUPPIERT_FEHLER;
        constructor(public payload: any,  public korrelation_id:string , public optPayload: any = null) {}
    }
export class GetMitteilungenGesendetGruppiertNichtAusgefuehrtAction implements Action {
    readonly type = GET_MITTEILUNGEN_GESENDET_GRUPPIERT_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type KommunikationQueryMitteilungenGesendetGruppiertActions =
    GetMitteilungenGesendetGruppiertAction
    | GetMitteilungenGesendetGruppiertAusfuehrenAction
    | GetMitteilungenGesendetGruppiertErfolgreichAction
    | GetMitteilungenGesendetGruppiertFehlerAction
    | GetMitteilungenGesendetGruppiertNichtAusgefuehrtAction
    ;
